<template>
  <div class="tz-search-overview">
    <h1 class="tz-search-overview__header" v-html="title" />
    <p
      v-for="item in renderIf(subText)"
      :key="item"
      class="tz-search-overview__text tz-search-overview__text--available"
      v-text="subText"
    />
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'TzSearchOverview',
  props: {
    /**
     * Title for the header
     */
    title: {
      type: String,
      required: true
    },
    /**
     * Subtext that will appear below the title
     */
    subText: {
      type: String
    }
  },
  methods: {
    /**
     * If statement vue hack to prevent <!-- --> comment
     * @param condition
     * @returns {[]}
     */
    renderIf(condition) {
      return condition ? [Math.random()] : [];
    }
  }
};
</script>
